<template>
  <div class="col-sm-12 col-md-12">
    <div class="row m-t-20">
      <div class="col-lg-12">
        <h4 class="card-title" style="font-size: medium">
          {{ impactArea.name }}
        </h4>
        <hr>
      </div>
    </div>
    <div v-if="impactArea" class="row">
      <div class="col-lg-12">
        <p class="m-t-0">
          {{ impactArea.description }}
        </p>
        <div v-for="(principle, index) in principles" :key="principle.id">
          <principle :audit-status="auditStatus" :audit-id="auditId" :auditor="auditor" :certification-id="certificationId" :impact-area="impactArea.impact_area" :principle="principle" :principle-id="principle.id" :principle-index="index+1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Principle from './Principle.vue';
export default {
  name: 'ImpactArea',
  components: { Principle },
  props: ['impactArea', 'auditId', 'auditStatus', 'auditor', 'certificationId'],
  data() {
    return {
      principles: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getPrinciples();
    },
    async getPrinciples() {
      try {
        const { data } = await this.$api.get(`audits/principles?impact_area=${this.impactArea.impact_area}`);
        this.principles = data;
      } catch (e) {
        console.error(e);
      }
    },
    tab(tabname) {
      this.activeTab = tabname;
    }
  }
}
</script>

<style scoped>
</style>
